import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState, getRecoilStateValue } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IUserResponse } from "../../../Orchestrator/Types/Index";
import { AccountAction } from "../../../Orchestrator/Types/Types/MyAccount/AccountAction";
import { IPaymentCard } from "../../../Orchestrator/Types/Interface/IPaymentCards";

interface UpdateAccountProgressParams {
    userData: IUserResponse;
    accountActions: AccountAction[];
}

export class UpdateAccountProgressAction extends BaseAction<void, UpdateAccountProgressParams> {
    override async run(): Promise<void> {
        try {
            const { userData, accountActions } = this.params!;
            let progress = 0;
            let updatedActions = accountActions.map((action) => ({
                ...action,
                isComplete: false,
            }));

            //Personal Information
            if (
                userData.title &&
                userData.firstName &&
                userData.lastName &&
                userData.email &&
                userData.phoneNumber &&
                userData.birthdate &&
                userData.gender &&
                userData.countryCode
            ) {
                progress += 25;

                updatedActions = updatedActions.map((action) =>
                    action.name === "personalInformation"
                        ? { ...action, isComplete: true }
                        : action
                );
            }

            //Companions
            if (userData?.additionalPassengers?.length > 0) {
                progress += 25;
                updatedActions = updatedActions?.map((action) =>
                    action.name === "companions"
                        ? { ...action, isComplete: true }
                        : action
                );
            }

            //Personalize Experience - General
            if (
                userData.railPreferences?.preferredOrigin &&
                userData.railPreferences?.preferredDestination &&
                userData.railPreferences?.classType &&
                userData.railPreferences?.ticketOption &&
                userData.railPreferences?.seating?.position != "" &&
                userData.railPreferences?.meal
            ) {
                progress += 25;

                updatedActions = updatedActions?.map((action) =>
                    action.name === "personalizeExperience"
                        ? { ...action, isComplete: true }
                        : action
                );
            }

            //Payments
            const paymentCards = getRecoilStateValue<IPaymentCard[]>("paymentCardsAtom");
            if (paymentCards && paymentCards.length > 0) {
                progress += 25;
                updatedActions = updatedActions?.map((action) =>
                    action.name === "paymentVouchers"
                        ? { ...action, isComplete: true }
                        : action
                );
            }

            updateRecoilState<AccountAction[]>("accountActionAtom", updatedActions);
            if (progress >= 0) {
                updateRecoilState("accountProgressAtom", progress);
            }
        } catch (error) {
            console.error("Error in UpdateAccountProgressAction:", error);
        }
    }
}

export const updateAccountProgressAction = new UpdateAccountProgressAction();